import React from "react";
import { useTranslation } from 'react-i18next';
import "./styles.css";

const ConfirmDialog = (props) => {
  const { t } = useTranslation('common');
  const {
    title,
    children,
    open,
    setOpen,
    onConfirm,
    loading = false,
    confirmText,
    cancelText,
    loadingText,
  } = props;

  if (!open) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      setOpen(false);
    }
  };

  return (
    <div className="confirm-dialog-backdrop" onClick={handleBackdropClick}>
      <div className="confirm-dialog-container" role="dialog" aria-labelledby="confirm-dialog-title">
        <div className="confirm-dialog-header">
          <h2 id="confirm-dialog-title" className="confirm-dialog-title">
            {title}
          </h2>
        </div>

        <div className="confirm-dialog-content">
          {children}
        </div>

        <div className="confirm-dialog-actions">
          <button
            className="confirm-dialog-button confirm-dialog-button-cancel"
            onClick={() => setOpen(false)}
            type="button"
            disabled={loading}
          >
            {cancelText || t('messages.no')}
          </button>
          <button
            className="confirm-dialog-button confirm-dialog-button-confirm"
            onClick={() => {
              onConfirm();
            }}
            type="button"
            disabled={loading}
          >
            {loading ? (
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div className="loading-spinner"></div>
                {loadingText || t('messages.deleting')}
              </span>
            ) : (
              confirmText || t('messages.yes')
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
